import dayjs from 'dayjs';
import ExportUserStatBtn from 'modules/Users/userStats/ExportUserStatBtn';
import ShowRowLogs from 'modules/Users/userStats/ShowRowLogs';
import UserStatConnection from 'modules/Users/userStats/UserStatConnection';
import { useMemo } from 'react';
import { UserStat } from 'shared/model/statistic.model';
import { UsageLog } from 'shared/model/usageLog.model';

type Props = {
  logs: UsageLog[];
};

const UserStats = ({ logs }: Props) => {
  const stats = useMemo(() => {
    let connections = logs.reduce((acc: UserStat[], log) => {
      if (log.type === 'CONNECTION') {
        const connection = {
          ...log,
          date: dayjs(log.date).subtract(1, 'second').toISOString(),
        };
        acc.push({
          connection,
          criteria: [],
        });
      }
      return acc;
    }, []);

    connections = logs.reduce((acc: UserStat[], log) => {
      if (log.type === 'CRITERIA') {
        const logDate = dayjs(log.date);
        let found = null;
        for (const connection of connections) {
          const connectionDate = dayjs(connection.connection.date);
          if (connectionDate.isSameOrBefore(logDate)) {
            found = connection;
          }
        }

        if (found) {
          found.criteria.push({
            criteria: log,
            configs: [],
          });
        }
      }
      return acc;
    }, connections);

    connections = logs.reduce((acc: UserStat[], log) => {
      if (log.type === 'CONFIG_SELECTED') {
        const logDate = dayjs(log.date);
        let connectionFound = null;
        for (const connection of connections) {
          const connectionDate = dayjs(connection.connection.date);
          if (connectionDate.isSameOrBefore(logDate)) {
            connectionFound = connection;
          }
        }

        if (connectionFound) {
          let criteriaFound = null;
          for (const criteria of connectionFound.criteria) {
            const criteriaDate = dayjs(criteria.criteria.date);
            if (criteriaDate.isSameOrBefore(logDate)) {
              criteriaFound = criteria;
            }
          }
          if (criteriaFound) {
            criteriaFound.configs.push(log);
          }
        }
      }
      return acc;
    }, connections);

    return connections.reverse();
  }, [logs]);

  return (
    <>
      <ExportUserStatBtn />
      <div className="text-left">
        {stats.map(stat => (
          <UserStatConnection key={stat.connection.id} stat={stat} />
        ))}
        <div className="my-l">
          <ShowRowLogs logs={logs} />
        </div>
      </div>
    </>
  );
};

export default UserStats;
